// extracted by mini-css-extract-plugin
export default {"Promo__Section":"Promo_Promo__Section__RX8YW","Promo__Box":"Promo_Promo__Box__xRT3V","Promo__Title":"Promo_Promo__Title__hjjoi"};